module.exports = __webpack_public_path__ + "static/media/p4.4ece602c.png";